<app-admin-header [header]="'Products and Services' | translator" [links]="[]" [breadcrumbs]="breadcrumbs" [stats]="[]">
</app-admin-header>

<div class="container-fluid p-4">
    <div class="btn-section mb-4 111" *ngIf="!showAddProductDialog">
        <div class="d-flex justify-content-end align-items-center">
            <button 
            *ngIf="permissionService.hasPermission('PRODUCT_TYPE', 'c')"
                    class="v4-btn-every align-items-center d-flex m-l-2" 
                    (click)="navigateToProductTypes()">
                <i class="pi pi-tags mx-2"></i>
                {{ "Manage Product Types" | translator }}
            </button>
            <button *ngIf="permissionService.hasPermission('PRODUCT_SERVICE', 'c')" 
                    class="v4-btn-every align-items-center d-flex" 
                    (click)="openAddProductDialog()">
                <i class="pi pi-plus-circle mx-2"></i>
                {{ "Add Service" | translator }}
            </button>
        </div>
    </div>
    
    <div class="services-grid" *ngIf="!spinner && servicesData.length > 0 && !showAddProductDialog">
        <div class="service-card" *ngFor="let service of servicesData; let i = index" [class.expanded]="service.isExpanded" (click)="toggleServiceExpansion(service)">
            <div class="service-card-main-content">
            <!-- Service Title -->
            <div class="service-title">
                <h3>{{ service?.title }}</h3>
                <p class="service-purpose">
                    <span *ngIf="service.isExpanded || !isTextLong(service?.purpose, 80)">{{ service?.purpose }}</span>
                    <span *ngIf="!service.isExpanded && isTextLong(service?.purpose, 80)">
                        {{ getTruncatedText(service?.purpose, 50) }}
                        <button class="see-more-btn" (click)="toggleServiceExpansion(service); $event.stopPropagation()">
                            {{ "See More" | translator }}
                        </button>
                    </span>
                </p>
            </div>

            <!-- Service Price -->
            <div class="service-price">
                <span class="price-amount" *ngIf="isNumericPrice(service?.basePrice)">{{ formatPriceDisplay(service?.basePrice) }}</span>
                <span class="price-amount price-text" *ngIf="!isNumericPrice(service?.basePrice)">{{ service?.basePrice }}</span>
                <img *ngIf="isNumericPrice(service?.basePrice)" 
                     src="assets/pdf/graphics/Saudi_Riyal_Symbol-1.png" 
                     alt="SAR" 
                     class="price-currency-icon currency-16" />
                <span class="price-vat" *ngIf="isNumericPrice(service?.basePrice) && service?.basePriceIncludesVAT">*{{ "including VAT" | translator }}</span>
            </div>

            <!-- Service Duration Badge -->
            <div class="service-duration-badge d-flex justify-content-start">
                <span class="duration-tag">{{ (service?.serviceDuration || '') | translator }}</span>
            </div>

            <!-- Get Service Button -->
            <div class="service-button" >
                <button *ngIf="!permissionService.hasPermission('PRODUCT_SERVICE', 'u') && !permissionService.hasPermission('PRODUCT_SERVICE', 'c')" class="get-service-btn" (click)="getService(service); $event.stopPropagation()">
                    {{ service?.actionButtonText }}
                </button>
            </div>

            <hr class="service-divider">

            <div class="service-card-preview" *ngIf="!service.isExpanded">

                <div class="service-description" *ngIf="service?.description?.text">
                    <h4 class="section-heading">{{ (service?.description?.heading || '') | translator }}</h4>
                    <p class="font-12px">
                        <span *ngIf="!isTextLong(service?.description?.text, 120)">{{ service?.description?.text }}</span>
                        <span *ngIf="isTextLong(service?.description?.text, 120)">
                            {{ getTruncatedText(service?.description?.text, 120) }}
                            <button class="see-more-btn" (click)="toggleServiceExpansion(service); $event.stopPropagation()">
                                {{ "See More" | translator }}
                            </button>
                        </span>
                    </p>
                </div>

                <div class="service-conditions" *ngIf="service?.conditionsAndRequirements?.items?.length">
                    <h4 class="section-heading">{{ (service?.conditionsAndRequirements?.heading || '') | translator }}</h4>
                    <ul class="conditions-list">
                        <li *ngFor="let condition of service?.conditionsAndRequirements?.items?.slice(0, 2)" 
                            [class.condition-met]="condition.isMet"
                            [class.condition-not-met]="!condition.isMet">
                            <i class="pi" [class.pi-check]="condition.isMet" [class.pi-times]="!condition.isMet"></i>
                            <span *ngIf="!isTextLong(condition.text, 100)">{{ condition.text }}</span>
                            <span *ngIf="isTextLong(condition.text, 100)">
                                {{ getTruncatedText(condition.text, 100) }}
                                <button class="see-more-btn" (click)="openProductDetailsModal(service); $event.stopPropagation()">
                                    {{ "See More" | translator }}
                                </button>
                            </span>
                        </li>
                        <li *ngIf="(service?.conditionsAndRequirements?.items?.length ?? 0) > 2" class="preview-more-indicator">
                            <i class="pi pi-ellipsis-h"></i>
                            <span>{{ (service?.conditionsAndRequirements?.items?.length ?? 0) - 2 }} {{ "more items" | translator }}</span>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="service-card-content" *ngIf="service.isExpanded">

                <div class="service-description" *ngIf="service?.description?.text">
                    <h4 class="section-heading">{{ (service?.description?.heading || '') | translator }}</h4>
                    <p class="font-12px 3">
                        {{ service?.description?.text }}
                    </p>
                </div>

                <div class="service-conditions" *ngIf="service?.conditionsAndRequirements?.items?.length">
                    <h4 class="section-heading">{{ (service?.conditionsAndRequirements?.heading || '') | translator }}</h4>
                    <ul class="conditions-list">
                        <li *ngFor="let condition of service?.conditionsAndRequirements?.items" 
                            [class.condition-met]="condition.isMet"
                            [class.condition-not-met]="!condition.isMet">
                            <i class="pi" [class.pi-check]="condition.isMet" [class.pi-times]="!condition.isMet"></i>
                            {{ condition.text }}
                        </li>
                    </ul>
                </div>

                <div class="service-target-audience" *ngIf="service?.targetAudience?.text">
                    <h4 class="section-heading">{{ (service?.targetAudience?.heading || '') | translator }}</h4>
                    <p class="font-12px">
                        {{ service?.targetAudience?.text }}
                    </p>
                </div>

                <div class="service-other-info" *ngIf="service?.otherInformation?.text">
                    <h4 class="section-heading">{{ (service?.otherInformation?.heading || '') | translator }}</h4>
                    <p class="other-info-text">
                        {{ service?.otherInformation?.text }}
                    </p>
                </div>
            </div>
            </div>

            <div class="service-card-bottom">
                <div class="service-expand-button" (click)="toggleServiceExpansion(service); $event.stopPropagation()">
                    <i class="pi" [class]="service.isExpanded ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
                    <span>{{ service.isExpanded ? ('Show Less' | translator) : ('Show More' | translator) }}</span>
                </div>

                <div class="service-actions at-card-action-icons">
                    <div class="at-action-icon-btn at-view-icon" 
                         (click)="openProductDetailsModal(service); $event.stopPropagation()" 
                         title="{{ 'View Details' | translator }}">
                        <i class="pi pi-eye"></i>
                    </div>
                    <div *ngIf="permissionService.hasPermission('PRODUCT_SERVICE', 'u')" 
                         class="at-action-icon-btn at-edit-icon" 
                         (click)="openEditProductDialog(service); $event.stopPropagation()" 
                         title="{{ 'Edit Service' | translator }}">
                        <i class="pi pi-pencil"></i>
                    </div>
                    <div *ngIf="permissionService.hasPermission('PRODUCT_SERVICE', 'd')" 
                         class="at-action-icon-btn at-delete-icon" 
                         (click)="deleteService(service._id!); $event.stopPropagation()" 
                         title="{{ 'Delete Service' | translator }}">
                        <i class="pi pi-trash"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- No Data Message -->
    <div class="d-flex justify-content-center" *ngIf="!spinner && servicesData.length === 0 && !showAddProductDialog">
        <app-no-data></app-no-data>
    </div>

    <!-- Loading Spinner -->
    <div class="d-flex justify-content-center" *ngIf="spinner && !showAddProductDialog">
        <p-progressSpinner [hidden]="!spinner" styleClass="w-4rem h-4rem pb-4" strokeWidth="8"
            fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
    </div>

    <!-- Pagination -->
    <div class="pagination-container mt-4" *ngIf="!showAddProductDialog">
        <p-paginator [hidden]="totalServices <= 10" (onPageChange)="onPageChange($event)" [first]="first"
            [rows]="rows" [totalRecords]="totalServices" [rowsPerPageOptions]="[10, 20, 30]">
        </p-paginator>
    </div>

    <!-- Add/Edit Product Form -->
    <div *ngIf="showAddProductDialog" class="product-form-container mt-4">
        <div class="d-flex justify-content-between align-items-center mb-4">
            <h2 class="product-form-header">
                <i class="pi" [class.pi-pencil]="isEditMode" [class.pi-plus-circle]="!isEditMode"></i>
                {{ (isEditMode ? ('Edit Service' | translator) : ('Add New Service' | translator)) }}
            </h2>
            <button type="button" class="btn btn-secondary" (click)="closeAddProductDialog()">
                <i class="pi pi-times mx-2"></i>
                {{ "Close" | translator }}
            </button>
        </div>
        
        <app-product-services-form
            [productService]="editingService"
            [isEditMode]="isEditMode"
            (formSubmit)="onProductServiceSubmit($event)"
            (formCancel)="closeAddProductDialog()"
            (formSuccess)="onFormSuccess()">
        </app-product-services-form>
    </div>
</div>

<app-footer></app-footer>

<!-- Order Dialog -->

<p-dialog 
    [(visible)]="showOrderDialog" 
    [modal]="true" 
    [closable]="true" 
    [draggable]="false" 
    [resizable]="false"
    [style]="{width: '95vw', maxWidth: '1200px'}"
    [header]="'Create New order request' | translator"
    (onHide)="closeOrderDialog()">
    
    <app-product-orders
        *ngIf="selectedServiceForOrder"
        [productService]="selectedServiceForOrder"
        (orderSubmit)="onOrderSubmit($event)"
        (orderCancel)="onOrderCancel()">
    </app-product-orders>
</p-dialog>


<!-- Comprehensive Product Details Modal -->
<p-dialog 
    [(visible)]="showProductDetailsDialog" 
    [modal]="true" 
    [closable]="true" 
    [draggable]="false" 
    [resizable]="false"
    [style]="{width: '95vw', maxWidth: '1200px'}"
    [header]="'Complete Service Details' | translator"
    (onHide)="closeProductDetailsDialog()">
    
    <div class="product-details-content" *ngIf="selectedServiceForDetails">
        <!-- Service Header -->
        <div class="service-header mb-4">
            <div class="d-flex justify-content-between align-items-start">
                <div>
                    <h2 class="service-title-large mb-2">{{ selectedServiceForDetails?.title }}</h2>
                    <div class="service-meta-info">
                        <span class="service-duration-badge">{{ selectedServiceForDetails?.serviceDuration }}</span>
                        <!-- <span class="service-status-badge" [class]="'status-' + selectedServiceForDetails?.status?.toLowerCase()">
                            {{ selectedServiceForDetails?.status | translator}}
                        </span> -->
                    </div>
                </div>
                <div class="service-price-large">
                    <div class="price-amount-wrapper" *ngIf="isNumericPrice(selectedServiceForDetails?.basePrice)">
                        <span class="price-amount-large">{{ formatPriceDisplay(selectedServiceForDetails?.basePrice) }}</span>
                        <img src="assets/pdf/graphics/Saudi_Riyal_Symbol-1.png" 
                             alt="SAR" 
                             class="price-currency-icon-large" />
                    </div>
                    <span class="price-amount-large price-text" *ngIf="!isNumericPrice(selectedServiceForDetails?.basePrice)">{{ selectedServiceForDetails?.basePrice }}</span>
                    <span class="price-vat-large" *ngIf="isNumericPrice(selectedServiceForDetails?.basePrice) && selectedServiceForDetails?.basePriceIncludesVAT">*{{'including VAT' | translator}}</span>
                </div>
            </div>
        </div>

        <!-- Service Purpose -->
        <div class="detail-section" *ngIf="selectedServiceForDetails?.purpose">
                <h4 class="section-heading-large">
                <i class="pi pi-info-circle me-2"></i>
                {{ "Service Purpose" | translator }}
            </h4>
            <div class="detail-content">
                <p>{{ selectedServiceForDetails?.purpose }}</p>
            </div>
        </div>

        <!-- Service Description -->
        <div class="detail-section" *ngIf="selectedServiceForDetails?.description?.text">
            <h4 class="section-heading-large">
                <i class="pi pi-file-text me-2"></i>
                {{ (selectedServiceForDetails?.description?.heading | translator) || ('Service Description' | translator) }}
            </h4>
            <div class="detail-content">
                <p>{{ selectedServiceForDetails?.description?.text }}</p>
            </div>
        </div>

        <!-- Conditions and Requirements -->
        <div class="detail-section" *ngIf="selectedServiceForDetails?.conditionsAndRequirements?.items?.length">
            <h4 class="section-heading-large">
                <i class="pi pi-list me-2"></i>
                {{ (selectedServiceForDetails?.conditionsAndRequirements?.heading | translator) || ('Conditions and Requirements' | translator) }}
            </h4>
            <div class="detail-content">
                <ul class="conditions-list-detailed">
                    <li *ngFor="let condition of selectedServiceForDetails?.conditionsAndRequirements?.items" 
                        [class.condition-met]="condition.isMet"
                        [class.condition-not-met]="!condition.isMet">
                        <i class="pi" [class.pi-check]="condition.isMet" [class.pi-times]="!condition.isMet"></i>
                        <span>{{ condition.text }}</span>
                    </li>
                </ul>
            </div>
        </div>

        <!-- Target Audience -->
        <div class="detail-section" *ngIf="selectedServiceForDetails?.targetAudience?.text">
            <h4 class="section-heading-large">
                <i class="pi pi-users me-2"></i>
                {{ (selectedServiceForDetails?.targetAudience?.heading | translator) || ('Target Audience' | translator) }}
            </h4>
            <div class="detail-content">
                <p>{{ selectedServiceForDetails?.targetAudience?.text }}</p>
            </div>
        </div>

        <!-- Other Information -->
        <div class="detail-section" *ngIf="selectedServiceForDetails?.otherInformation?.text ">
            <h4 class="section-heading-large">
                <i class="pi pi-dollar me-2"></i>
                {{ (selectedServiceForDetails?.otherInformation?.heading | translator) || ('OTHER INFORMATION' | translator) }}
            </h4>
            <div class="detail-content">
                <p>{{ selectedServiceForDetails?.otherInformation?.text }}</p>
            </div>
            <!-- <div class="detail-content">
                <div class="pricing-info-card">
                    <p class="pricing-text">
                        {{ "Price for querying a single financial statement is" | translator }} 
                        <strong>{{ selectedServiceForDetails?.otherInformation?.perQueryPrice }}</strong> 
                        {{ selectedServiceForDetails?.otherInformation?.perQueryPriceCurrency }}
                        <span *ngIf="selectedServiceForDetails?.otherInformation?.perQueryPriceIncludesVAT">*{{ "including VAT" | translator }}</span>
                    </p>
                </div>
            </div> -->
        </div>

        <!-- Service Actions -->
        <div class="detail-section">
            <h4 class="section-heading-large">
                <i class="pi pi-cog me-2"></i>
                {{ "Available Actions" | translator }}
            </h4>
            <div class="detail-content">
                <div class="action-buttons-grid">
                    <button *ngIf="!permissionService.hasPermission('PRODUCT_SERVICE', 'u') && !permissionService.hasPermission('PRODUCT_SERVICE', 'c')" class="action-btn primary-btn" (click)="getService(selectedServiceForDetails)">
                        <i class="pi pi-shopping-cart me-2"></i>
                        {{ selectedServiceForDetails?.actionButtonText || ('Get the Product' | translator) }}
                    </button>
                    <button *ngIf="permissionService.hasPermission('PRODUCT_SERVICE', 'u')" 
                            class="action-btn secondary-btn" 
                            (click)="openEditProductDialog(selectedServiceForDetails)">
                        <i class="pi pi-pencil me-2"></i>
                        {{ "Edit Service" | translator }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</p-dialog>

<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
